module.exports = __webpack_public_path__ + "img/edit.1cc03f85.svg";